import type { MaybeRefOrGetter } from 'vue';
import { computed, toValue } from 'vue';
import { formatFilesize } from '#layers/assets/utils/format-filesize';

export interface FileInfoInput {
	fileName: string;
	fileSize?: number | string | null;
	mediaType: string;
	title?: string | null;
	description?: string | null;
}

export function useFileInfo(file: MaybeRefOrGetter<FileInfoInput | null | undefined>) {
	const computedFile = computed(() => toValue(file));

	const title = computed(() => {
		const f = computedFile.value;
		if (!f) return;
		return f.description ?? f.title ?? f.fileName;
	});

	const isImage = computed(() => computedFile.value?.mediaType?.startsWith('image/') ?? false);
	const metadataLine = computed(() => {
		const f = computedFile.value;
		if (!f) return;

		const fileSize = Number(f.fileSize);

		return [
			fileSize ? formatFilesize(fileSize) : undefined,
			f.mediaType,
		].filter(Boolean).join(' • ');
	});

	return {
		title,
		isImage,
		metadataLine,
	};
}
